<div class="spinner-component">
  <div class="row">
    <div class="col-md-3"></div>
    <div class="col-md-6 content">
      <div class="field-group">
        <div class="custom-spinner">
        <div class="spinner-content">
          <span>{{cfetLabels.cfet_spinner.header_content}}<br>
            <p>{{cfetLabels.cfet_spinner.subcontent}}</p></span>
        </div>
      </div>
    </div>
    </div>
    <div class="col-md-3"></div>
  </div>
</div>